import React from 'react'
import {cn} from '@/lib/utils'

function Skeleton({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
    return <div className={cn('animate-pulse rounded-md bg-primary/10', className)} {...props} />
}

export {Skeleton}

const ProductTileSkeleton: React.FC = () => {
    return (
        <div className="flex flex-col w-full h-full">
            {/* Product Image */}
            <Skeleton className="aspect-square rounded-md" data-testid="productTileSkeleton" />
            <div className="flex mt-2 space-x-2">
                {/* Stars */}
                <Skeleton className="w-1/2 h-4 rounded-md" data-testid="productTileSkeleton" />
                {/* Ratings text */}
                <Skeleton className="w-1/2 h-4 rounded-md" data-testid="productTileSkeleton" />
            </div>
            {/* Product Name */}
            <Skeleton className="w-full h-8 mt-2 rounded-md" data-testid="productTileSkeleton" />
            {/* Price */}
            <Skeleton className="w-1/2 h-4 mt-2 rounded-md" data-testid="productTileSkeleton" />
            {/* Quantity and Add to Cart */}
            <div className="flex mt-4 space-x-2">
                <Skeleton className="w-1/2 h-12 rounded-md" data-testid="productTileSkeleton" />
                <Skeleton className="w-1/2 h-12 rounded-md" data-testid="productTileSkeleton" />
            </div>
        </div>
    )
}

ProductTileSkeleton.displayName = 'ProductTileSkeleton'

export default ProductTileSkeleton
